
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { fetchData, handleAddItem, handleUpdateItem } from '../../utils/data'
import {  BookingTrip } from '../../types'
import i18n from '../../i18n';
const lang = i18n.language === "ar" ? "ar" : "en";
interface BookingState {
	bookedTrips: BookingTrip[];
    booking: BookingTrip | null;
	loading: boolean;
}

export const addBookTrip = createAsyncThunk("post/BookTrip", async (data: any) => {
	const res = await handleAddItem(data, `BookTrip/bookTrip`, "POST");
	return res;
});

export const fetchBookTrips = createAsyncThunk("get/BookTrips", async (id: string | number) => {
	const data = await fetchData(`BookTrip/getBookTrips?UserID=${id}&lang=${lang}`, true);
	return data;
});
export const cancelBook = createAsyncThunk("PUT/returnBook", async ({ userId, bookId }: any) => {
	await handleUpdateItem("", `BookTrip/returnBook?userId=${userId}&bookId=${bookId}`, "PUT");
});

export const changePaymentMethodInBookTrip = createAsyncThunk("PUT/changePaymentMethodInTrip", async ({ bookId, userId, paymentMethod }: { bookId: number, userId: string | number | undefined, paymentMethod: string }) => {
	await handleUpdateItem("", `BookTrip/changePaymentMethodInBook?userId=${userId}&paymentMethod=${paymentMethod}&bookId=${bookId}`, "PUT");
});

export const fetchBookByTripId = createAsyncThunk("get/BookByTripId", async (bookId: number) => {
	const data = await fetchData(`BookTrip/getBookById?bookId=${bookId}&lang=${lang}`, true);
	return data;
});
const initialState: BookingState = {
	bookedTrips: [],
	booking: null,
	loading: false,
}


const bookTripSlice = createSlice({
	name: 'bookTrip',
	initialState,
	reducers: {},
     extraReducers: (builder) => {
		builder
			// Fetch Books
			.addCase(fetchBookTrips.pending, (state) => {
				state.loading = true;
			})
			.addCase(fetchBookTrips.fulfilled, (state, action) => {
				state.loading = false;
				state.bookedTrips = action.payload || [];
			})
			
			.addCase(fetchBookByTripId.pending, (state) => {
				state.loading = true;
			})
			.addCase(fetchBookByTripId.fulfilled, (state, action) => {
				state.loading = false;
				state.booking = action.payload || [];
			})
	}
})


export default bookTripSlice.reducer
